import { QueryFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export type ConditionType = {
  id: string;
  title: string;
  active: boolean;
};

type ConditionTypesResponse = {
  success: boolean;
  conditionTypes?: ConditionType[];
};

const _mockConditionTypes: ConditionType[] = [
  { id: 'investor-delivery', title: 'Investor Delivery', active: true },
  { id: 'preliminary', title: 'Preliminary', active: true },
  { id: 'underwriting', title: 'Underwriting', active: true },
  { id: 'post-closing', title: 'Post-Closing', active: true },
  { id: 'closing', title: 'Closing', active: true },
];

const getConditionTypes: QueryFunction<
  ConditionType[],
  ['/encompass/condition-types']
> = async () => {
  if (isMockServices()) return await mock(_mockConditionTypes);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<ConditionTypesResponse>(
    '/encompass/condition-types',
    {
      method: 'GET',
    },
  );

  return (response.data?.conditionTypes ?? []).filter((type) => type.active);
};

export default getConditionTypes;
